import { useEffect, useState } from 'react';
import { Card, Table, Pagination } from 'react-bootstrap';
import PageHeader1 from '../../components/common/PageHeader1';
import EditButton from "../../components/common/EditButton";
import DeleteButton from "../../components/common/DeleteButton";
import apiClient from "../../utils/api";
import { toast } from 'react-toastify';

function ModelList() {
    const [models, setModels] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [perPage] = useState(10);

    const fetchModels = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get(`accounts/models?page=${currentPage}&per_page=${perPage}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setModels(response.data.data || []);
            setTotalPages(Math.ceil(response.data.total / response.data.per_page));
            setLoading(false);
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error loading models');
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchModels();
    }, [currentPage]);

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this model?')) {
            return;
        }
        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.delete(`accounts/models/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Model deleted successfully');
            fetchModels();
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error deleting model');
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <PageHeader1 pagetitle='Models List' righttitle='Add Model' link='/accounts/models-add' routebutton={true} permission='models.create' />
                
                <Card className="mb-3">
                    <Card.Body>
                        <Table responsive striped hover>
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Model Name</th>
                                    <th>Brand</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {models.map((model) => (
                                    <tr key={model.id}>
                                        <td>#{model.id}</td>
                                        <td>{model.name}</td>
                                        <td>{model.brand?.name}</td>
                                        <td>
                                            <span className={`badge ${model.is_active ? 'bg-success' : 'bg-warning'}`}>
                                                {model.is_active ? 'Active' : 'Inactive'}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="btn-group" role="group">
                                                <EditButton
                                                    to={`${process.env.PUBLIC_URL}/accounts/models-edit/${model.id}`}
                                                    permission="models.edit"
                                                />
                                                <DeleteButton
                                                    onDelete={() => handleDelete(model.id)}
                                                    permission="models.delete"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div className="d-flex justify-content-center mt-3">
                            <Pagination>
                                <Pagination.First 
                                    onClick={() => handlePageChange(1)} 
                                    disabled={currentPage === 1}
                                />
                                <Pagination.Prev 
                                    onClick={() => handlePageChange(currentPage - 1)} 
                                    disabled={currentPage === 1}
                                />
                                
                                {[...Array(totalPages)].map((_, idx) => (
                                    <Pagination.Item
                                        key={idx + 1}
                                        active={idx + 1 === currentPage}
                                        onClick={() => handlePageChange(idx + 1)}
                                    >
                                        {idx + 1}
                                    </Pagination.Item>
                                ))}
                                
                                <Pagination.Next 
                                    onClick={() => handlePageChange(currentPage + 1)} 
                                    disabled={currentPage === totalPages}
                                />
                                <Pagination.Last 
                                    onClick={() => handlePageChange(totalPages)} 
                                    disabled={currentPage === totalPages}
                                />
                            </Pagination>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default ModelList;